@import "styles/variables";

.noBookings {
  margin: 20px 0;
  font-family: "Helvetica Neue Light", Helvetica, Arial, sans-serif;
  color: var(--color-black-transparent);
}
